import React from 'react'

import NavButton from './navButton'
import IconClose from '../../icons/close'

import styles from './buttons.module.css'

const CloseButton = ({ item }) => (
  <NavButton keyName="Escape" item={item} className={styles.iconCloseWrapper}>
    <IconClose className={styles.iconClose} />
  </NavButton>
)

export default CloseButton
